const BASE_KEY = '@Mural'

export const getKey = (key) => `${BASE_KEY}/${key}`

export const isAuthenticated = () => localStorage.getItem(getKey('token')) !== null

export const getToken = () => localStorage.getItem(getKey('token'))

export const setToken = (token) => {
  localStorage.setItem(getKey('token'), token)
}

export const logout = () => {
  localStorage.removeItem(getKey('token'))
}

export const setUser = (user) => {
  localStorage.setItem(getKey('user'), JSON.stringify(user))
}

export const getUser = () => JSON.parse(localStorage.getItem(getKey('user')))
